/**
 * 售后管理相关接口
 * 酒店 / 旅游线路 / 租车 / 达人 独立申请接口
 */
import { http, peiwantHttp } from "@/http/axios";

// ==================== 通用类型 ====================

/** 售后申请通用响应 data */
export interface RefundApplyData {
  order_id: number;
  order_no: string;
  refund_id: number;
  refund_no: string;
  refund_status: number;
  status_text: string;
  refund_money: string;
}

export interface BaseRefundResponse {
  code: number;
  message: string;
  data: RefundApplyData;
}

// ==================== 酒店售后 ====================

/** 发起酒店售后申请 */
export interface HotelRefundParams {
  /** 订单ID */
  order_id: number;
  /** 申请原因 */
  apply_reson: string;
  /** 申请描述 */
  apply_desc: string;
  /** 退款金额 */
  refund_money: number;
  /** 凭证图片URL，逗号分隔 */
  apply_img: string;
}

/**
 * POST /home/hotel-refund/apply
 * 发起酒店售后申请
 */
export function applyHotelRefund(params: HotelRefundParams) {
  return http.post<BaseRefundResponse>("/home/hotel-refund/apply", params);
}

// ==================== 旅游线路售后 ====================

/** 发起旅游线路售后申请 */
export interface TourRefundParams {
  /** 订单ID */
  order_id: number;
  /** 申请原因 */
  apply_reson: string;
  /** 申请描述 */
  apply_desc: string;
  /** 退款金额 */
  refund_money: number;
  /** 凭证图片URL，逗号分隔 */
  apply_img: string;
}

/**
 * POST /home/tour-refund/apply
 * 发起旅游线路售后申请
 */
export function applyTourRefund(params: TourRefundParams) {
  return http.post<BaseRefundResponse>("/home/tour-refund/apply", params);
}

// ==================== 租车售后 ====================

/** 租车售后申请请求体 POST /home/car-refund/apply（JSON） */
export interface CarRefundParams {
  order_id: number;
  /** 申请原因分类 */
  apply_reason: string;
  /** 申请说明 */
  apply_desc: string;
  /** 退款金额 */
  refund_money: number;
  /** 凭证图片 URL，逗号分隔 */
  apply_img: string;
}

/** 租车售后申请成功 data */
export interface CarRefundApplyData {
  refund_id: number;
  refund_status: number;
  status_text: string;
  create_time: string;
}

export interface CarRefundApplyResponse {
  code: number;
  message: string;
  data: CarRefundApplyData;
}

/**
 * POST /home/car-refund/apply
 * 发起租车售后申请
 */
export function applyCarRefund(params: CarRefundParams) {
  return http.post<CarRefundApplyResponse>("/home/car-refund/apply", params);
}

// ==================== 取消售后 ====================

/**
 * POST /home/tour-refund/cancel
 * 取消旅游线路售后申请
 */
export function cancelTourRefund(refundId: number) {
  return http.post("/home/tour-refund/cancel", { refund_id: refundId });
}

/**
 * POST /home/hotel-refund/cancel
 * 取消酒店售后申请
 */
export function cancelHotelRefund(refundId: number) {
  return http.post("/home/hotel-refund/cancel", { refund_id: refundId });
}

/**
 * POST /home/car-refund/cancel
 * 取消租车售后申请，请求体：`{ refund_id }`
 */
export function cancelCarRefund(refundId: number) {
  return http.post("/home/car-refund/cancel", { refund_id: refundId });
}

// ==================== 达人/导游售后 ====================

/** 达人订单申请退款请求体 */
export interface GuideRefundParams {
  /** 订单ID */
  id: number;
  /** 退款理由 */
  reason: string;
}

export interface GuideRefundResponse {
  code: number;
  message: string;
  data?: string; // msg 文字提示
}

/**
 * POST /orderRefund
 * 达人/导游订单申请退款（BLW系统：peiwan.banly.com.cn）
 */
export function applyGuideRefund(params: GuideRefundParams) {
  return peiwantHttp.post<GuideRefundResponse>("api/orderRefund", params);
}
